<div class="d-flex flex-column" *ngIf="attributes; else none">
    <span *ngIf="attributes.attack">attack: <span
            [ngClass]="{'green': diff && attributes.attack > 0, 'red': diff && attributes.attack < 0}">{{diff &&
            attributes.attack > 0 ? '+' : ''}}{{attributes.attack *
            multiplier}}</span></span>
    <span *ngIf="attributes.defense">defense: <span
            [ngClass]="{'green': diff && attributes.defense > 0, 'red': diff && attributes.defense < 0}">{{diff &&
            attributes.defense > 0 ? '+' : ''}}{{attributes.defense *
            multiplier}}</span></span>
    <span *ngIf="attributes.vitality">vitality: <span
            [ngClass]="{'green': diff && attributes.vitality > 0, 'red': diff && attributes.vitality < 0}">{{diff &&
            attributes.vitality >
            0 ? '+' :
            ''}}{{attributes.vitality * multiplier}}</span></span>
    <span *ngIf="attributes.stamina">stamina: <span
            [ngClass]="{'green': diff && attributes.stamina > 0, 'red': diff && attributes.stamina < 0}">{{diff &&
            attributes.stamina > 0 ? '+' : ''}}{{attributes.stamina *
            multiplier}}</span></span>
</div>
<ng-template #none>
    -None
</ng-template>